import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from "../../../hooks/useRtoaster";
import CommonValidation from "../../../common/commonValidation";
import { apiKeyCheck, getDouhanList, registerCompanion, versionGetApi } from "../../../const";
import messageConst from "../../../const/messageConst";
import common from "../../../resources/js/common/common";
import { Button } from "../../atoms/button";
import { Label } from '../../atoms/label';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { LabelInputForm } from "../../molecules/labelInputForm";
import { RadioButtonForm } from '../../molecules/radioButtonForm';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/accompany.css';

const MembershipConfirmAccompanyContainer = (props) => {
    const {
        state,
        login,
        checkIn,
        checkOut,
        membershipReserveComf,
        setAccompanyPath,
        inputAccompanyInfo,
        setInputAccompanyInfo,
        setDisplayType,
        resvKaiinken,
    } = props;

    const loginType = login.loginType;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();

    const [linkList, setLinkList] = useState([]);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false });
    const [flgList, setFlgList] = useState([]);
    let clickedFlg = false;

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        if (membershipReserveComf.pageKbn === "membershipResvComp") {
            // 予約完了画面
            if (loginType === "MEMBER") {
                setLinkList([
                    { path: "/reserve/top", label: "HOME" },
                    { path: "/reserve/hotel/search", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" },
                    { path: "/reserve/hotel/reserveComplete", label: "予約完了" },
                    { path: "/reserve/hotel/inputAccompany", label: "同行者情報入力" }
                ]);
            } else if (loginType === "CRAWL") {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/searchResult", label: "検索結果" },
                    { path: "/reserve/hotel/reserveComplete", label: "予約完了" },
                    { path: "/reserve/hotel/inputAccompany", label: "同行者情報入力" }
                ]);
            }
        } else if (membershipReserveComf.pageKbn === "membershipResvComf") {
            // 予約内容確認画面
            if (loginType === "MEMBER") {
                setLinkList([
                    { path: "/reserve/top", label: "HOME" },
                    { path: "/reserve/hotel/search", label: "ホテル予約" },
                    { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                    { path: "/reserve/hotel/inputAccompany", label: "同行者情報入力" },
                ]);
            } else if (loginType === "CRAWL") {
                setLinkList([
                    { path: "/reserve/hotel/crawlSearch", label: "ホテル予約" },
                    { path: "/reserve/hotel/hotelBookingConfirmDetail", label: "予約内容確認" },
                    { path: "/reserve/hotel/inputAccompany", label: "同行者情報入力" },
                ]);
            }
        }
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        setAccompanyPath("/reserve/hotel/inputAccompany");
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }


    const getDateToString = (date) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const dispDate = new Date(date);
        const y = dispDate.getFullYear();
        const m = dispDate.getMonth() + 1;
        const d = dispDate.getDate();
        return `${y}年${m}月${d}日(${youbi[dispDate.getDay()]})`;
    }

    // 「変更」ボタン押下時
    const onClicChange = () => {
        history.push("/reserve/hotel/inputAccompany");
    }

    // 「決定」ボタン押下時
    const onClicDecide = () => {
        if (!clickedFlg) {
            clickedFlg = true;
            // 同行者情報取得
            let riyoKaiinkenSyubetCd = "";
            if (membershipReserveComf.riyoKaiinkenSyubetCd) {
                // 予約変更で設定済みの利用会員権種別がある場合は設定済みの値を使用する
                riyoKaiinkenSyubetCd = membershipReserveComf.riyoKaiinkenSyubetCd;
            } else {
                resvKaiinken.forEach((value) => {
                    if (value.keiyakuNo === membershipReserveComf.keiyakuNo) {
                        riyoKaiinkenSyubetCd = value.riyoKaiinkenSyubetCd;
                    }
                });
            }
            common.doPost(registerCompanion, {
                yoyakuNo: membershipReserveComf.yoyakuNo,
                pointKaiinId: login.memberCode,
                roomWariList: getRoomWariListToReg(),
            }, afterRegisterCompanion);
        }
    }

    const afterRegisterCompanion = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            history.push("/reserve/hotel/completeAccompany");
            return;
        }
        setErrorInfo({ errorMessage: [messageConst.REGISTRATION_ERROR], errorFlg: true });
        window.scroll({ top: 0, behavior: 'smooth' })
    }

    /**
     * 登録用roomWariListを生成する
     */
    const getRoomWariListToReg = () => {
        let regRoomWariList = [];
        let regRiyoNo = 1;
        inputAccompanyInfo.forEach(room => {
            let regDoukouList = [];
            let regRoomSeq = 0;
            room.doukouList.forEach(doukou => {
                // riyoNamkn未入力の同行者は登録対象外
                if (doukou.riyoNamkn.length) {
                    regDoukouList.push({
                        riyoNo: doukou.riyoNo == 1 ? 1 : ++regRiyoNo,
                        riyoNamkn: doukou.riyoNamkn,
                        riyoNamkj: doukou.riyoNamkj,
                        roomSeq: ++regRoomSeq,
                        customerSeq: doukou.customerSeq,
                        saveFlg: doukou.saveFlg
                    });
                }
            });
            regRoomWariList.push({
                seq: room.seq,
                roomTypeCd: room.roomTypeCd,
                rmTypeNam: room.rmTypeNam,
                ninzuMale: room.ninzuMale,
                ninzuFemale: room.ninzuFemale,
                ninzuChild: room.ninzuChild,
                ninzuYoji: room.ninzuYoji,
                ninzuBaby: room.ninzuBaby,
                doukouList: regDoukouList,
            });
        });
        return regRoomWariList;
    }

    const deleteReserveConf = () => {
        store.dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: {} } })
    }

    return (
        <div className={state.displayType === "complete" ? "hiddenItem" : "userInputInnerWrapper"}>
            <BreadCrumb
                breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                linkStyle={styles.link}
                linkList={linkList}
                lastLabel="同行者入力内容確認"
                lastLabelClassName="lastLabel"
            />
            <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
            <div className="userInputWrapper">
                <div className={"stayInfo"} style={styles.userInput}>
                    <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                        <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                    </div>
                    <Label
                        label={"ご予約情報"}
                        className="titleLabel"
                    />
                    <div className={"reservationContentsWrap"}>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="予約番号"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={membershipReserveComf.yoyakuNo}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="ホテル名"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={membershipReserveComf.shisetsuName}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="チェックイン"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={getDateToString(membershipReserveComf.checkInDate)}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                        <div className="reserveInfoContentBlock">
                            <div className="reserveInfoContent">
                                <Label
                                    label="チェックアウト"
                                    className="reserveInfoTitleGray"
                                />
                                <Label
                                    label={getDateToString(membershipReserveComf.checkOutDate)}
                                    className="confirmContentLabel"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* 同行者情報入力フォーム */}
            {inputAccompanyInfo.length != 0 ? <>
                {getRoomWariListToReg().map((value, roomIndex) =>
                    <div key={value.roomTypeCd + roomIndex}>
                        <div className="userInputWrapper3">
                            <div><Label label={(roomIndex + 1) + "室目"} className="roomIndex" /></div>
                        </div>
                        <div className="representInputWrapper">
                            <div className="userInput2">
                                <div className={"stayInfo"} style={styles.userInput}>
                                    <div className="accompanyWrap">
                                        <Label label="お部屋タイプ" className="popupLabel" />
                                        <Label label={value.rmTypeNam} className="inputContentLabel1" />
                                    </div>
                                    <div className="accompanyWrap">
                                        <Label label="ご利用人数" className="popupLabel" />
                                        <div className="inputContentLabel1">男性：{value.ninzuMale}名　女性：{value.ninzuFemale}名　小学生：{value.ninzuChild}名　幼児：{value.ninzuYoji}名　乳児：{value.ninzuBaby}名</div>
                                    </div>
                                    {/* <Label label="名前（カナ・漢字）" className="popupLabel" /> */}
                                    {value.doukouList.map((accompany, accompanyIndex) =>
                                        <div>
                                            <div style={{ display: "flex" }}>
                                                <Label label={(accompanyIndex + 1) + "人目"} className="popupLabel" />
                                            </div>
                                            <div className={useMediaFlag ? "accompanyInputAreaMobile" : "accompanyInputArea"}>
                                                <div className={useMediaFlag ? "accompanyInputTextWrapMobile" : "accompanyInputTextWrap"}>
                                                    <Label label="カナ：" className="accompanyLabel" />
                                                    <Label label={accompany.riyoNamkn} className="inputContentLabel1" />
                                                </div>
                                                <div className={useMediaFlag ? "accompanyInputTextWrapMobile" : "accompanyInputTextWrap"}>
                                                    <Label label="漢字：" className="accompanyLabel" />
                                                    <Label label={accompany.riyoNamkj} className="inputContentLabel1" />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="btnToReserveConfirmWrapper">
                    <div class={"confirmboxWrap"}>
                        <Button buttonText="変更" className="btnBack btnSpStyle" onClick={onClicChange} buttonClassName="serachBtnText" />
                        <Button buttonText="決定" className="btnToConfirm btnSpStyle2" onClick={onClicDecide} buttonClassName="serachBtnText" />
                    </div>
                </div></>
                : <Label label="同行者情報が存在しません。" className="noneAccompanyInfoLabel" />}
            <div className="backTopInputUser">
                <Link to={loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} style={styles.bottomLink} onClick={() => deleteReserveConf()} >ホテル検索TOPへ戻る</Link>
            </div>
            <div><MembershipFooterContainer className={"reservationResultFooterBase"} /></div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        mealInfoList: state.mealInfoList,
        membershipReserveComf: state.membershipReserveComf,
        resvKaiinken: state.resvKaiinken,
        inputAccompanyInfo: state.inputAccompanyInfo

    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setInputAccompanyInfo: (item) => {
            dispatch({ type: "INPUT_ACCOMPANY_INFO", payload: { inputAccompanyInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipConfirmAccompanyContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "white",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}
